import ProjectUser_checkDelete from "./check-project-user-delete"
import {USER_VIEW_TYPE} from "../../@type";
import ApiProject from "../../../../gd/api/project";
import UserAssignment_Collection from "../../model/collection";
import ApiProjectUser from "../../../../gd/api/project-user";
import {makePublicTagShared} from "../../../../model2/tag/access-options"

export default class ModalProjectUserActions {

    public params           : any
    public updateCallback   : callback
    public reassignCallback : {(view: USER_VIEW_TYPE, userAssignments?: UserAssignment_Collection | null): void}
    public onReassignDone?  : callback
    public closeModal       : callback

    constructor(params: any, updateCallback: callback, reassignCallback: {(view: USER_VIEW_TYPE, userAssignments?: UserAssignment_Collection | null): void}, closeModal: callback) {
        this.params             = params

        this.updateCallback     = updateCallback
        this.reassignCallback   = reassignCallback
        this.closeModal         = closeModal
    }

    onAccessSelect = async (value: any) => {

        try {
            const response = await ApiProjectUser.updateAccess(this.params.projectUser.projectId, this.params.projectUser.userId, value).promise()

            const userAssignments: UserAssignment_Collection = UserAssignment_Collection.initFromJson(response, [this.params.projectUser.userId])

            if (!!response.session) {
                this.params.projectUser.access = value

                this.updateCallback(()=>{
                    if (this.params.onChange) this.params.onChange(this.params.projectUser)
                })
            } else {

                this.onReassignDone = () => this.onAccessSelect(value).then(()=> {
                    this.reassignCallback(USER_VIEW_TYPE.DEFAULT)
                })

                this.reassignCallback(USER_VIEW_TYPE.REASSIGN_ACCESS, userAssignments)
            }

        } catch(e) {
            console.error()
        }
    }

    onWatchAllSelect = (value: boolean) => {
        this.params.projectUser.watchAll = value

        // callback
        if (this.params.onChange) this.params.onChange(this.params.projectUser)

        const request = gd.api.ProjectUser.updateWatchAll(this.params.projectUser.projectId, this.params.projectUser.userId, value)
        request.done(()=>{
            this.updateCallback()
        })
    }

    checkDelete = () => {
        return ProjectUser_checkDelete(this.params.projectUser, this.params.projectUsers)
    }

    onDeleteConfirmed = async () => {

        const {canDelete} = this.checkDelete()

        if (!canDelete) {
            this.reassignCallback(USER_VIEW_TYPE.REASSIGN_DELETE, null);
        } else {
            try {
                await makePublicTagShared(this.params.projectUser.projectId)

                const response = await ApiProject.deleteUser(this.params.projectUser.projectId, this.params.projectUser.userId, false).promise()

                const hasAssignments = !response.session

                if (hasAssignments || this.params.projectUser.isInheritedTeam) {

                    const userAssignments: UserAssignment_Collection = UserAssignment_Collection.initFromJson(response, [this.params.projectUser.userId])

                    this.reassignCallback(USER_VIEW_TYPE.REASSIGN_DELETE, userAssignments);
                } else {
                    this.closeModal()
                }

            } catch (e) {
                throw e
            }
        }
    }

    reassignUserItems = async (userAssignments: UserAssignment_Collection, reassignType: USER_VIEW_TYPE) => {

        try {
            await ApiProject.reassignItemsV2(this.params.projectUser.projectId, userAssignments).promise();

            if (reassignType === USER_VIEW_TYPE.REASSIGN_DELETE) {
                await this.onDeleteConfirmed()
            }

            if (reassignType === USER_VIEW_TYPE.REASSIGN_ACCESS && this.onReassignDone) {
                this.onReassignDone()
            }

        } catch (e) {
            console.error(e)
            this.closeModal()
        }
    }
}
